var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"message",staticClass:"message-text",class:{ 'mouse-down': _vm.mouseDown },domProps:{"innerHTML":_vm._s(_vm.msg)},on:{"mousedown":_vm.onMouseDown,"mouseup":_vm.onMouseUp}})
}
var staticRenderFns = []

export { render, staticRenderFns }